import loadSessionModule from './modules/Session.module';
import loadOrdersModule from './modules/Orders.module';
import loadCustomerModule from './modules/Customer.module';
const loadOrderOverviewModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule(), loadCustomerModule(), loadOrdersModule()],
});
export default loadOrderOverviewModule;
